<template>
    <div>
        <b-card style="padding:0px 30px 0px 30px;">

            <b-row>
                <b-col md="6">
                    <h3>
                        Dangerous Goods
                    </h3>
                </b-col>
                <b-col md="6" style="text-align: right;">
                    <base-button @click="addDangerousGood()" type="danger" class="mb-4 bg-danger">Add Dangerous Goods</base-button>
                </b-col>
            </b-row>

            <b-row style="font-size: 9pt; font-weight: bold; padding: 3px 0px 6px 0px; text-decoration: underline;">
                <b-col class="less-padding" style="flex-basis: 20%; ">
                    Class
                </b-col>

                <b-col class="less-padding" style="flex-basis: 50%;">
                    Quantity
                </b-col>

                <b-col class="less-padding" style="flex-basis: 20%;">
                    Description
                </b-col>

                <b-col class="less-padding" style="flex-basis: 10%; align-content: center">

                </b-col>


            </b-row>

            <b-row v-for="(item, index) in model.listOfDangerousGoods" :key="index"
                style="padding: 3px 0px 3px 0px;font-size: 9pt; align-content: center;">


                <b-col class="less-padding" style="flex-basis: 20%;">
                    {{ item.dangerousGoods.dangerousGoodsClass }}
                </b-col>


                <b-col class="less-padding" style="flex-basis: 50%;">
                    {{ item.dangerousGoods.dangerousGoodsQuantity }}
                </b-col>

                <b-col class="less-padding" style="flex-basis: 20%;">
                    {{ item.dangerousGoods.dangerousGoodsDescription }}

                </b-col>

                <b-col class="less-padding" style="align-content: center;flex-basis: 10%; padding: 0px; display: flex">
                    <base-button style="padding: 0px 5px 5px 5px; max-height: 30px;" class="bg-danger" type="danger"
                        icon @click="editDangerousGood(item, index)">
                        <b-icon font-scale="0.9" icon="pencil-square"></b-icon></base-button>
                    <base-button style="padding: 0px 5px 5px 5px;color: red; max-height: 30px;" class="bg-white"
                        type="danger" @click="removeDangerousGood(index)">
                        <b-icon font-scale="0.9" icon="trash"></b-icon></base-button>
                </b-col>




            </b-row>

            <b-row>
                <b-col style="text-align: center;font-size: 10pt;margin-top: 5px;color: red;">Please add dangerous good information to proceed.</b-col>
            </b-row>

        </b-card>

        <DangerousGoodsModal ref="pastDangerousGoodModal" @saveDangerousGoodsItem="saveDangerousGoodsItem($event)" />

    </div>
</template>

<script>
import BaseInput from "../../../components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../../assets/data/entsiaLOVs";
import DangerousGoodsModal from "../modals/dangerousGoodsModal.vue";

export default {
    name: "DangerousGoodsList",
    //policy_id: "",
    //selectedCustomerId: 0,
    props: {
        model: {
            type: Object
        },
    },
    data() {
        return {
            dangerousGoodsList: [],
            // vehicleEditMode: 'add',
            // selectedItem: null,
            // selectedIdx: null,
            // freightTaskOptions: entsiaDropDowns.freightTaskOptions,
            // vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
        }
    },
    methods: {
        formatDate(dateString) {
            return this.$moment(new Date(dateString)).format("YYYY-MM-DD")
        },
        removeDangerousGood(idx) {
            this.$emit('deleteDangerousGoodsItem', idx);
        },
        saveDangerousGoodsItem(_item) {
            this.$emit('saveDangerousGoodsItem', { item: _item, selectedItemIndex: this.selectedItemIndex, editMode: this.editMode });
        },
        addDangerousGood() {
            this.editMode = "add";

            this.selectedItemIndex = 0;
            this.selectedItem = {
                "dangerousGoods": {
                    "dangerousGoodsClass": "",
                    "dangerousGoodsQuantity": "",
                    "dangerousGoodsDescription": ""
                }
            }

            this.$refs["pastDangerousGoodModal"].openDangerousGoodsModal(this.editMode, this.selectedItem, this.selectedItemIndex);
        },
        editDangerousGood(_row, idx) {
            //this.$refs['pastClaimModal'].hide();

            console.log(_row);

            this.editMode = "edit";

            this.selectedItem = structuredClone(_row);
            this.selectedItemIndex = idx;

            this.$refs["pastDangerousGoodModal"].openDangerousGoodsModal(this.editMode, this.selectedItem, this.selectedItemIndex);

        }
        // saveVehicle() {
        //     this.$emit('saveVehicle', this.selectedItem);
        //     this.$refs['vehicle-modal'].hide();
        // },
        // closeVehicleModal() {
        //     this.$refs['vehicle-modal'].hide();
        // },
        // openVehicleModal(_mode, _item, _idx) {

        //     //console.log(_mode,_item,_idx);

        //     console.log(_item.vehicle.vehicleType);

        //     this.vehicleEditMode = _mode;
        //     this.selectedItem = _item;
        //     this.selectedIdx = _idx;
        //     this.$refs['vehicle-modal'].show();
        // },
    },
    components: {
        BaseInput,
        [Select.name]: Select,
        [Option.name]: Option,
        //Spinner,
        //FileUpload,
        VueMultiselectComponent,
        DangerousGoodsModal
    },
    async mounted() {
        //console.log("c13");
        //this.$refs['vehicle-modal'].show();

        //console.log(this._selectedItem);
        //this.selectedItem = this._selectedItem;
    }
}
</script>

<style></style>